/**
 * Membership plans (WP4-MEMBERSHIP), a Marketplace add-on: in-house plans
 * with monthly or annual dues collected through Square, included services
 * with yearly counters, and member pricing posted to the ledger.
 *
 * Deep links: `/membership?tab=members&member=<enrollment id>`,
 * `/membership?tab=plans`, `?tab=candidates`, `?tab=declines`.
 */
import { defineManifest } from '@velora/contracts';
import { MEMBERSHIP_FEATURE } from '@velora/contracts/membership';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'membership',
    title: 'Membership',
    version: '0.1.0',
    owner: 'WP4-MEMBERSHIP',
    entitlementKey: MEMBERSHIP_FEATURE,
    permissions: ['ledger.view', 'ledger.post_payment', 'ledger.adjust'],
    routes: [
      {
        id: 'membership',
        path: '/membership',
        title: 'Membership',
        officeScope: 'location-or-all',
        permission: 'ledger.view',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Membership',
        group: 'revenue',
        routeId: 'membership',
        icon: 'badge-percent',
        order: 40,
        permission: 'ledger.view',
      },
    ],
    commands: [
      {
        id: 'membership.open',
        title: 'Go to Membership',
        keywords: ['membership', 'plan', 'dues', 'in-house', 'uninsured', 'club'],
        routeId: 'membership',
        permission: 'ledger.view',
      },
    ],
    sseEntityKeys: ['membership_enrollment', 'membership_plan'],
    phiReadPoints: [
      'membership.members',
      'membership.member',
      'membership.candidates',
      'membership.declines',
      'membership.patients',
    ],
  }),
  pages: {
    membership: () => import('./MembershipPage.js'),
  },
});
